---
meta:
  - title: Qué es un cliente - IUSPRO Docs
  - description: Entienda qué es un cliente y para qué sirve dentro de IUSPRO.
---

# Qué es un cliente

Un **cliente** es un espacio de trabajo dentro de IUSPRO para agrupar varios chats, archivos e instrucciones alrededor de un mismo cliente.

Piense en él como una mezcla de:

- **carpeta**
- **contexto persistente**
- **historial de trabajo**

En un cliente puede tener:

- varios chats sobre ese cliente
- instrucciones permanentes
- archivos adjuntos
- expedientes vinculados como fuente de contexto
- colaboración con otras personas de su organización

## ¿Para qué sirve?

Sirve para no repetir lo mismo en cada conversación.

Por ejemplo, si está trabajando para Empresa X, puede crear un cliente con:

- el nombre del cliente
- instrucciones sobre cómo quiere que responda la IA
- archivos importantes
- expedientes relacionados

Luego, cada nuevo chat dentro de ese cliente parte de ese contexto.

## ¿Qué NO es un cliente?

Un cliente no reemplaza al chat.

El cliente es el **espacio organizador**.
El chat es la **conversación concreta** que usted tiene dentro de ese espacio.

Por eso, un mismo cliente puede tener muchos chats:

- un chat para estrategia
- otro para redactar
- otro para revisar documentos
- otro para dudas puntuales

## Cuándo conviene usar un cliente

Conviene usarlo cuando:

- va a trabajar un cliente durante varios días o semanas
- necesita varios chats relacionados con ese cliente
- quiere mantener instrucciones fijas
- necesita reutilizar archivos o expedientes sin volver a adjuntarlos cada vez
- varias personas van a trabajar el mismo cliente, pero cada una con sus propios chats

## Cliente compartido: idea clave

**Nota:** Solo disponible en planes empresariales.

Cuando comparte un cliente, se comparte el contexto del cliente, no las conversaciones privadas de cada persona.

La forma simple de entenderlo es:

- **el cliente se comparte**
- **los chats siguen siendo personales**

## Siguiente lectura

- Aprenda [cómo usar clientes](/guias/proyectos-como-usar)
- Aprenda [cómo compartir clientes](/guias/proyectos-compartir-proyectos)
- Entienda la diferencia entre [clientes y expedientes](/guias/proyectos-y-expedientes)
